import { coreServiceBaseURL, masterServiceBaseURL } from "@/services/agent";
import authService from "@/services/authService";
import axios from "axios";
import { LookUpModel, UserLookUpModel } from "./ResponseModel";
import preLoader from "@/services/preLoader";

export async function loadLegalEntity(): Promise<LookUpModel[]> { 
    preLoader.show()
    const response = await axios.get(`${coreServiceBaseURL}v1/legalentity/getlookUp`, {
        headers: { Authorization: `Bearer ${authService.getToken()}` }
    });
    var data: LookUpModel[] = [];
    if (response && response.data.isSuccess) {
        data.push();
        data = [...response.data.data];
        preLoader.hide()
    }
    return data;
}


export async function loadSourceSystemInstanceLookup(): Promise<LookUpModel[]> { 
    preLoader.show()
    const response = await axios.get(`${coreServiceBaseURL}v1/sourcesysteminstance/getlookUp`, {
        headers: { Authorization: `Bearer ${authService.getToken()}` }
    });
    
    var data: LookUpModel[] = [];
    
    if (response) {
        data.push();
        data = [...response.data];
        preLoader.hide()
    }

    return data;
}

export async function getUserList(): Promise<UserLookUpModel[]> { 
    preLoader.show()
    const response = await axios.get(`${masterServiceBaseURL}v1/user/GetUserLookUp?subscriptionId=${authService.getSubscriptionId()}`, {
        headers: { Authorization: `Bearer ${authService.getToken()}` }
    });
    
    var data: UserLookUpModel[] = [];
    
    if (response) {
        data.push();
        data = [...response.data.result.data];
        preLoader.hide()
    }

    return data;
}